import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../components/pages/environments/environmentsReducer';
import {
  appRoutes,
  findAppRouteByPathname,
  isRouteEnabledForOrgType,
} from '../constants/appRoutes';
import useSweepNavigate from '../navigation-utils/useSweepNavigate';

export const useRestrictedRouteGuard = () => {
  const { pathname } = useLocation();
  const { navigate } = useSweepNavigate();
  const defaultCreationEnv = useSelector(selectDefaultCreationEnvironment);
  const orgType = defaultCreationEnv?.orgType;

  useEffect(() => {
    const appRoute = findAppRouteByPathname(pathname);
    if (appRoute && !isRouteEnabledForOrgType(appRoute, orgType)) {
      navigate(appRoutes.getStarted.route, { replace: true });
    }
  }, [orgType, pathname, navigate]);
};
